/**
 * Splits `count` tiles into the fewest rows of at most `maxPerRow`, as evenly
 * as possible, earlier rows taking the extra one: 5 of 4 → [3, 2], 7 of 4 →
 * [4, 3], 10 of 4 → [4, 3, 3]. Each row then stretches to the full width, so
 * no row is left with a gap or a lone tile.
 */
export function balanceRows(count: number, maxPerRow: number): number[] {
  if (count <= 0) return [];

  const perRow = Math.max(1, Math.floor(maxPerRow));
  const rows = Math.ceil(count / perRow);
  const base = Math.floor(count / rows);
  const extra = count % rows;

  return Array.from({ length: rows }, (_, row) => base + (row < extra ? 1 : 0));
}
